import requestByGateway from '@/request/request.gateway';
import config from '@/config';
import qs from 'qs';

const staff = {
	/**
	 * 获取参数
	 * @typedef {Object} StaffListParams
	 * @property {number} school_id 学校id
	 * @property {number} page 页码
	 * @property {number} page_size 每页大小
	 */

	/**
	 *
	 * @param {StaffListParams} params
	 * @returns {Promise<APIResponse<APIList<Staff>>>}
	 */
	getStaffList(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.admin}/staff/v2/search/page`,
			headers: config.headers,
			params
		});
	},

	/**
	 * 根据职工ids获取职工信息
	 * @param data
	 * @returns {AxiosPromise}
	 */
	getStaffInfoListByStaffIds(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.schoolstruct}/schoolstruct/v2/staff/ids/list`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	}
};
export default staff;
